// Stuti Weaves — Cart cleanup for linked finishing services
// If a 'Saree Fall & Hemming' line item exists without a matching saree
// (same _finishing_token property), remove it. Runs on /cart and /checkout
// pages on load, and after any /cart/change.js call.
(function () {
  'use strict';
  var FINISHING_VARIANT_ID = 48661199880427; // Saree Fall & Hemming

  function cleanupCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;

        // Build map of tokens that have a matching non-service saree
        var sareeTokens = {};
        cart.items.forEach(function (it) {
          if (it.variant_id === FINISHING_VARIANT_ID) return;
          var token = it.properties && it.properties._finishing_token;
          if (token) sareeTokens[token] = true;
        });

        // Find orphan finishing services (no matching saree)
        var orphans = cart.items.filter(function (it) {
          if (it.variant_id !== FINISHING_VARIANT_ID) return false;
          var token = it.properties && it.properties._finishing_token;
          // Orphan if no token at all (legacy add), or token has no matching saree
          return !token || !sareeTokens[token];
        });

        if (!orphans.length) return;

        // Remove each orphan via /cart/change.js
        return Promise.all(orphans.map(function (o) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: o.key, quantity: 0 })
          });
        })).then(function () {
          // If we're on the /cart page, reload to reflect changes visually
          if (location.pathname === '/cart') location.reload();
        });
      })
      .catch(function () {});
  }
  window.stutiCleanupCart = cleanupCart;

  // Intercept fetch to re-run cleanup after any cart change
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (url, opts) {
      var promise = origFetch.apply(this, arguments);
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (u.indexOf('/cart/change') !== -1 || u.indexOf('/cart/update') !== -1) {
        promise.then(function () { setTimeout(cleanupCart, 150); }).catch(function () {});
      }
      return promise;
    };
  }

  // Intercept XMLHttpRequest (some themes still use jQuery.ajax)
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
        this.addEventListener('load', function () { setTimeout(cleanupCart, 150); });
      }
      return origOpen.apply(this, arguments);
    };
  }

  // Run on cart + checkout pages on load
  function init() {
    if (location.pathname === '/cart' || location.pathname.indexOf('/checkout') === 0) {
      cleanupCart();
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
